import React from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-dark text-white py-5">
      <Container>
        <Row>
          <Col md={3} className="mb-4">
            <h5 className="fw-bold mb-3">Company</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <a href="/about" className="text-white text-decoration-none">
                  About Us
                </a>
              </li>
              <li className="mb-2">
                <a href="/contact" className="text-white text-decoration-none">
                  Contact
                </a>
              </li>
              <li className="mb-2">
                <a href="/blog" className="text-white text-decoration-none">
                  Blog
                </a>
              </li>
            </ul>
          </Col>
          <Col md={3} className="mb-4">
            <h5 className="fw-bold mb-3">Product</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <a href="#features" className="text-white text-decoration-none">
                  Features
                </a>
              </li>
              <li className="mb-2">
                <a href="#pricing" className="text-white text-decoration-none">
                  Pricing
                </a>
              </li>
              <li className="mb-2">
                <Link to="/tickets/list" className="text-white text-decoration-none">
                  Support
                </Link>
              </li>
            </ul>
          </Col>
          <Col md={3} className="mb-4">
            <h5 className="fw-bold mb-3">Resources</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <a href="/docs" className="text-white text-decoration-none">
                  Documentation
                </a>
              </li>
              <li className="mb-2">
                <a href="#pricing" className="text-white text-decoration-none">
                  FAQs
                </a>
              </li>
              <li className="mb-2">
                <a
                  href="https://x.ai/api"
                  className="text-white text-decoration-none"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  API
                </a>
              </li>
            </ul>
          </Col>
          <Col md={3} className="mb-4">
            <h5 className="fw-bold mb-3">Stay Connected</h5>
            <div className="mb-3">
              <input
                type="email"
                className="form-control"
                placeholder="Enter your email"
                aria-label="Newsletter signup"
              />
              <Button color="primary" className="mt-2">
                Subscribe
              </Button>
            </div>
            <div className="d-flex gap-3">
              <a
                href="https://x.com"
                className="text-white"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bx bxl-twitter fs-4"></i>
              </a>
              <a
                href="https://linkedin.com"
                className="text-white"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bx bxl-linkedin fs-4"></i>
              </a>
              <a
                href="https://facebook.com"
                className="text-white"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bx bxl-facebook fs-4"></i>
              </a>
            </div>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col className="text-center">
            <p className="mb-0">&copy; 2025 Your SaaS Company. All rights reserved.</p>
            <div className="d-flex justify-content-center gap-3 mt-2">
              <a href="/privacy" className="text-white text-decoration-none">
                Privacy Policy
              </a>
              <a href="/terms" className="text-white text-decoration-none">
                Terms of Service
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
